module.exports = __webpack_public_path__ + "static/media/fail.7fc009de.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/fail.jpg
 ** module id = 15
 ** module chunks = 0
 **/